module.exports = __webpack_public_path__ + "media/newstyle/images/creditcard-f40b65ef9fcc65190a34e10de92114b7.png";